import React from 'react';
import encodeString from 'encodeString';

function Tags({ tags, path }) {
  if (!tags.length > 0) return null;
  const basePath = path.replace(':searchParams*', '');

  return (
    <div className="link-tags hidden--until-l text-ellipsis">
      <ul className="link-tags__list ">
        {tags.map((item) => <li key={item} className="link-tags__item"><a href={`${basePath}${encodeString(item.toLowerCase())}/`}>{item}</a></li>)}
      </ul>
    </div>
  );
}

export default Tags;
